// The whole script for the prerendered home page: the shared stylesheet and
// the menu behaviour. No React — see landing.html.
import '../index.css';
import { wireMenus } from './menu';

wireMenus();
